import { render, staticRenderFns } from "./course7.vue?vue&type=template&id=3598745a&scoped=true&"
import script from "./course7.vue?vue&type=script&setup=true&lang=js&"
export * from "./course7.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./course7.vue?vue&type=style&index=0&id=3598745a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3598745a",
  null
  
)

export default component.exports